export default __webpack_public_path__ + "static/media/flower-rose-icon.76fa6f8a.svg";